// helpers

const normalizeShift = (raw) => ({
  id: raw.shift_id,
  workerId: raw.user_id ,
  entryDate: raw.entry_date ,
  workingHours: Number(raw.working_hours || 0),
  payment: Number(raw.net_amount || 0),
  eligibleDate: raw.eligible_date_for_payment || null,
  paymentStatus: raw.payment_status || 'pending',
  companyName:raw.companyName || "-",
  departmentName:raw.departmentName || "-",
});

const formatINR = (value) =>
  `₹${Number(value || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;

const formatDatePart = (isoString) => {
  if (!isoString) return '—';
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};

const formatTimePart = (isoString) => {
  if (!isoString) return '';
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};

// yyyy-mm-dd for a Date, used with <input type="date" />
const toDateInputValue = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

const STATUS_STYLES = {
  payoutGenerated: 'bg-emerald-50 text-emerald-700',
  pending: 'bg-amber-50 text-amber-700',
};

const STATUS_LABELS = {
  payoutGenerated: 'Paid',
  pending: 'Pending',
};


export {normalizeShift,formatINR,formatDatePart,formatTimePart,toDateInputValue,STATUS_STYLES , STATUS_LABELS}